var _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancelar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ico_doc_cancelado_Emg",
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.757,
    height: 76.728,
    viewBox: "0 0 65.757 76.728",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1598",
    "data-name": "Elipse 1598",
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#7eccc9",
    opacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_401_",
    transform: "translate(-38.074 2.837)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_68_",
    transform: "translate(50.164 10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_697_",
    d: "M89.779,53.995V13.834A3.833,3.833,0,0,0,85.946,10H54a3.833,3.833,0,0,0-3.834,3.834v46A3.833,3.833,0,0,0,54,63.672H83.412",
    transform: "translate(-50.164 -10)",
    fill: "none",
    stroke: "#3b0310",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_696_",
    d: "M100.367,431.714v2.556A3.833,3.833,0,0,0,104.2,438.1h26.072",
    transform: "translate(-93.978 -378.042)",
    fill: "none",
    stroke: "#3b0310",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_695_",
    d: "M361.428,60.2h2.556a3.833,3.833,0,0,1,3.834,3.834V97.809",
    transform: "translate(-321.813 -53.814)",
    fill: "none",
    stroke: "#3b0310",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_694_",
    x2: 19.169,
    transform: "translate(10.223 7.668)",
    fill: "none",
    stroke: "#3b0310",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_693_",
    x2: 24.28,
    transform: "translate(7.667 15.335)",
    fill: "none",
    stroke: "#3b0310",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_691_",
    x2: 24.28,
    transform: "translate(7.667 23.003)",
    fill: "none",
    stroke: "#3b0310",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_688_",
    x2: 24.28,
    transform: "translate(7.667 30.67)",
    fill: "none",
    stroke: "#3b0310",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_685_",
    x2: 10.223,
    transform: "translate(17.891 46.005)",
    fill: "none",
    stroke: "#3b0310",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_684_",
    d: "M190.735,311.224c1.7,0,1.7,1.022,3.407,1.022s1.7-1.022,3.408-1.022,1.7,1.022,3.408,1.022",
    transform: "translate(-172.844 -272.887)",
    fill: "none",
    stroke: "#3b0310",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_70_",
    transform: "translate(54.642 47.065)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_686_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_701_",
    d: "M90.454,311.438a5.106,5.106,0,1,1,5.106-5.106A5.112,5.112,0,0,1,90.454,311.438Z",
    transform: "translate(-85.347 -301.225)",
    fill: "#fce3ed"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_682_",
    transform: "translate(27.475 5.112)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_698_",
    d: "M312.081,363.1a10.857,10.857,0,1,1,10.857-10.857A10.869,10.869,0,0,1,312.081,363.1Z",
    transform: "translate(-301.224 -341.388)",
    fill: "#fce3ed"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_69_",
    transform: "translate(89.811 59.871)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_675_",
    y1: 6.325,
    x2: 6.325,
    fill: "none",
    stroke: "#3b0310",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_666_",
    x2: 5.904,
    y2: 5.904,
    transform: "translate(0.211 0.211)",
    fill: "none",
    stroke: "#3b0310",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelar);
export default __webpack_public_path__ + "static/media/cancelar.25986f280140cdba1254e87cbe611998.svg";
export { ForwardRef as ReactComponent };